import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import React, { Component } from "react";

import {
  _45_MIN_INDIVIDUAL_90834,
  DIAGNOSTIC_INTERVIEW_90792,
} from "@/components/Provider/ScheduleAvailability/constants";
import Button from "@/components/UI/Button";
import CardSecondary from "@/components/UI/Card/CardSecondary";
import { daySelectHandler } from "@/lib/helpers/daySelectHandler";
import { eventTypeDisplayNameFactory } from "@/components/Provider/ScheduleAvailability/ActiveScheduleDetails";
import { getQueryParams } from "@/utils/filters";
import images from "@/utils/images";
import { providerRequests } from "@/api/(requests)/provider";
import { scheduleRequests } from "@/api/(requests)/schedule";
import { ScheduleWidgets } from "@/portals/(shared)/(schedule)/ScheduleWidgets";
import { sharedRequests } from "@/api/(requests)/shared";
import { showAlertWithAction } from "@/redux/actions/alerts";

class OnBehalfOfSchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appointmentDetail: null,
      dateStr: "",
      eventType:
        getQueryParams("providerType", props.location.search) === "Prescriber"
          ? DIAGNOSTIC_INTERVIEW_90792
          : _45_MIN_INDIVIDUAL_90834,
      isDisabled: true,
      patientAvatar: images("./common/avatar.png"),
      patientId: getQueryParams("patientId", this.props.location.search),
      patientName: "",
      providerAvatar: images("./common/avatar.png"),
      providerId: this.props.match.params.providerId,
      providerName: getQueryParams("providerName", this.props.location.search),
      providerType: getQueryParams("providerType", this.props.location.search),
      selectedDate: null,
      selectedTimeSlot: null,
      slotsCount: 0,
      timeSlots: null,
      timeSlotsLoading: false,
    };
  }

  /**
   * Used to catch navigations to pages rending this component with incorrect URL parameters. This can happen in
   * edge cases where a user opens the page as one user type (say CSE), logs in as another user type (say BHS) and
   * reloads the page. Users types may have overlapping routes with different parameter requirements.
   * @returns {boolean} Whether or not URL parameters are valid
   */
  urlParamsValid = () => {
    if (!this.state.patientId || !this.state.providerId) {
      this.props.showAlertWithAction("Patient and provider must be selected when scheduling");

      return false;
    }

    return true;
  };

  componentDidMount = async () => {
    if (!this.urlParamsValid()) {
      return;
    }

    this.resetDaySelection();
    let patient = await sharedRequests.fetch_patient_details({
      urlParams: { patientId: this.state.patientId },
    });
    let patientAvatar = patient.user.avatar_url
      ? patient.user.avatar_url
      : images("./common/avatar.png");
    let provider = await providerRequests.fetch_provider_profile({
      searchParams: { providerId: this.state.providerId },
    });
    let providerAvatar = provider.user.avatar_url
      ? provider.user.avatar_url
      : images("./common/avatar.png");
    let patientName = patient.user["first_name"] + " " + patient.user["last_name"];

    this.setState({
      patientAvatar,
      patientName,
      providerAvatar,
    });
  };

  getAvailableSchedules = (dateString, providerId) => {
    if (!this.urlParamsValid()) {
      return;
    }

    let urlParams = {
      dateString,
      eventType: this.state.eventType,
      patientId: this.state.patientId,
      providerId,
      providerType:
        this.state.providerType === "Behavioral Specialist" ? "BEHAVIORAL" : "PRESCRIBE",
      tz: this.props.timezone,
    };

    return sharedRequests.available_schedules({ urlParams });
  };

  scheduleCall = () => {
    const { timezone } = this.props;
    const combinedDateTime = this.state.selectedDate + " " + this.state.selectedTimeSlot.time_slot;

    const data = {
      event_type: this.state.eventType,
      local_date_time: moment
        .tz(combinedDateTime, "YYYY-MM-DD hh:mm a", timezone)
        .format("YYYY-MM-DD HH:mm"),
      patient_id: this.state.patientId,
      provider_id: this.state.providerId,
      timezone,
    };

    return scheduleRequests.post_schedule({ data });
  };

  onTimeSlotClick = (slotValue) => {
    this.setState({
      isDisabled: false,
      selectedTimeSlot: slotValue,
    });
  };

  onEventTypeChange = (eventType) => {
    this.setState(
      {
        eventType: eventType,
      },
      () => this.resetDaySelection(),
    );
  };

  onConfirmSlotSubmit = () => {
    this.scheduleCall()
      .then(() => {
        let appointmentDetail = {
          patientName: this.state.patientName,
          providerName: this.state.providerName,
        };

        this.setState({
          appointmentDetail: appointmentDetail,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  resetDaySelection() {
    let today = moment().tz(this.props.timezone).format("YYYY-MM-DD");
    let searchDate = this.state.selectedDate ? this.state.selectedDate : today;

    daySelectHandler(searchDate, this);
  }

  scheduleSuccessPopUp = (appointmentDetail) => {
    const eventDisplay = eventTypeDisplayNameFactory(this.state.eventType)
      ? eventTypeDisplayNameFactory(this.state.eventType)
      : "Initial Consultation";

    return (
      <div className="overlay">
        <div className="ScheduleSuccess-wpr">
          <CardSecondary className="mx-lg-auto">
            <div className="px-5 py-4 text-center">
              <img alt="success" className="mb-4" src={images("./common/successCheck.svg")} />
              <p className="ScheduleSuccess__text fs-17 tw:font-bold">Appointment Scheduled</p>
              <p className="ScheduleSuccess__text fs-15 mb-4" data-private>
                {" "}
                {eventDisplay} between {appointmentDetail.patientName} &{" "}
                {appointmentDetail.providerName} has been successfully scheduled.
              </p>

              <Button className="Btn Btn--pri" onClick={() => this.props.history.goBack()}>
                OK
              </Button>
            </div>
          </CardSecondary>
        </div>
      </div>
    );
  };

  render() {
    let timeSlotConf = {
      isDisabled: this.state.isDisabled,
      selectedDate: this.state.selectedDate,
      selectedTimeSlot: this.state.selectedTimeSlot,
    };

    return (
      <div data-public>
        <div className="Schedule__wpr p-lg-4 mx-auto row no-gutters">
          <div className="col-10 pb-2" style={{ width: "100%" }}>
            <Link className="PatientProfile-back-link" onClick={() => this.props.history.goBack()}>
              <img alt="Back" className="img-fluid" src={images("./common/solidBckBtn.svg")} />
              <p className="d-inline ml-2">Back to Care Team</p>
            </Link>

            <CardSecondary
              className="PatientProfile__CreatePlan-wpr py-1 px-3 px-xl-4 d-block"
              style={{ maxWidth: "100%" }}
            >
              <div className="d-flex align-items-center">
                <img
                  alt="Patient Avatar"
                  className="PatientProfile__90DaysPlan img-fluid"
                  src={this.state.patientAvatar}
                  width="55px"
                />

                <img
                  alt="Provider Avatar"
                  className="PatientProfile__90DaysPlan img-fluid"
                  src={this.state.providerAvatar}
                  style={{ marginLeft: -20 }}
                  width="55px"
                />

                <div>
                  <p
                    className="text-white fs-18"
                    data-private
                    style={{ marginLeft: 15, marginTop: 20 }}
                  >
                    <b>{this.state.patientName + " & " + this.state.providerName}</b>
                  </p>

                  <p
                    className="text-white fs-16"
                    data-private
                    style={{ marginLeft: 15, marginTop: -15 }}
                  >
                    Video Consultation between Patient and {this.state.providerType}
                  </p>
                </div>
              </div>
            </CardSecondary>
          </div>

          {this.state.appointmentDetail && this.scheduleSuccessPopUp(this.state.appointmentDetail)}

          <ScheduleWidgets
            dateStr={this.state.dateStr}
            eventType={this.state.eventType}
            onConfirmSlotSubmit={this.onConfirmSlotSubmit}
            onEventTypeChange={this.onEventTypeChange}
            onTimeSlotClick={this.onTimeSlotClick}
            that={this}
            timeSlotConf={timeSlotConf}
            timeSlots={this.state.timeSlots}
            timeSlotsLoading={this.state.timeSlotsLoading}
            timezone={this.props.timezone}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    timezone: state.auth.timezone,
  };
};

export default connect(mapStateToProps, { showAlertWithAction })(OnBehalfOfSchedule);
